import React from 'react'

import Flex from '../Flex'
import Icon from '../Icon'
import Text from '../Text'
import Box from '../Box'

import MenuList from './components/MenuList'
import MultiValueRemove from './components/MultiValueRemove'
import Option from './components/Option'
import SelectCascaderInput from './SelectCascaderInput'

import { componentStyles } from './config'
import { StyledSelect } from './styled'

import { SelectInputProps } from './Select.types'

const FormatCreateLabel: React.FC<{ inputValue: string }> = ({ inputValue }) => (
  <Flex alignItems='center' columnGap='8px'>
    <Icon name='Plus-solid' color='black50' size={16} />
    <Box>
      <Text as='span' color='black50'>
        Tambah{' '}
      </Text>
      <Text as='span' color='black75' weight='bold'>
        {inputValue}
      </Text>
    </Box>
  </Flex>
)

const SelectInput: React.FC<SelectInputProps> = ({
  isClearable = false,
  type = 'regular',
  isError = false,
  size = 'regular',
  isCreatable = false,
  formatCreateLabel,
  components,
  ...props
}) => {
  const isCheckboxType: boolean = type === 'checkbox'

  return (
    <StyledSelect
      classNamePrefix='select'
      styles={componentStyles}
      closeMenuOnSelect={!props.isMulti}
      hideSelectedOptions={false}
      isMulti={props.isMulti}
      isError={isError}
      size={size}
      isClearable={isClearable}
      onBlur={props.onLeave}
      formatCreateLabel={(inputValue) =>
        formatCreateLabel?.(inputValue) || <FormatCreateLabel inputValue={inputValue} />
      }
      components={{
        Option: (props) => <Option {...props} isCheckboxType={isCheckboxType} />,
        MenuList: (props) => <MenuList {...props} isCreatable={isCreatable} />,
        MultiValueRemove,
        ...components,
      }}
      isValidNewOption={() => isCreatable}
      {...props}
    />
  )
}

export default Object.assign(SelectInput, {
  Cascader: SelectCascaderInput,
})
